import { createAction } from 'typesafe-actions';

export enum DASHBOARD {
  FETCH_DASHBOARD = 'dashboard/FETCH_DASHBOARD',
  FETCH_DASHBOARD_SUCCESS = 'dashboard/FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_FAILURE = 'dashboard/FETCH_DASHBOARD_FAILURE',
}

export const fetchDashboard = createAction(DASHBOARD.FETCH_DASHBOARD)();
